import {Typography} from 'components/Typography';
import {FC} from 'react';
import style from './style.module.scss';

export const EventXOffer: FC = () => {
    return (
        <div className={style.main}>
            <Typography className={style.offerText} variant={'label-16-r'}>
                Мероприятия доступны гостям старше 18 лет.
            </Typography>
            <a
                href={'https://static.simplewine.ru/upload/medialibrary/8e8/8e862ce9d55f82db85b6c10389991094.pdf '}
                target={'_blank'}
                rel={'noopener noreferrer'}
            >
                <Typography variant={'label-16-r'}>Ссылка на оферту</Typography>
            </a>
        </div>
    );
};
